import { useEffect, useState } from "react";
import { DIWALI_ENDS } from "@/lib/diwali";

const pad = (n) => String(n).padStart(2, "0");

/** Large ticking countdown to Diwali night (Nov 8, 2026). Gold boxes on dark. */
export const DiwaliCountdown = ({ className = "" }) => {
  const [left, setLeft] = useState(DIWALI_ENDS - Date.now());
  useEffect(() => {
    const id = setInterval(() => setLeft(DIWALI_ENDS - Date.now()), 1000);
    return () => clearInterval(id);
  }, []);
  if (left <= 0) return null;
  const units = [
    ["Days", Math.floor(left / 86400000)],
    ["Hours", Math.floor((left % 86400000) / 3600000)],
    ["Mins", Math.floor((left % 3600000) / 60000)],
    ["Secs", Math.floor((left % 60000) / 1000)],
  ];
  return (
    <div data-testid="diwali-countdown" className={`flex items-center gap-2.5 sm:gap-3 ${className}`}>
      {units.map(([label, v]) => (
        <div key={label} className="text-center">
          <div className="w-14 sm:w-[4.25rem] py-2 sm:py-2.5 border border-[#F5C542]/40 bg-[#F5C542]/10 backdrop-blur-sm font-display text-2xl sm:text-3xl text-[#F5C542] tabular-nums leading-none">
            {pad(v)}
          </div>
          <div className="text-[0.55rem] font-mono tracking-[0.18em] uppercase text-[#FFFFFF]/60 mt-1.5">{label}</div>
        </div>
      ))}
    </div>
  );
};
